import axios from "axios";

export const Provider = {
    namespaced: true,
    state: {
        recent_scans: [],
        all_scans: 0,
        all_valid_scans: 0,
        all_invalid_scans: 0,
        today_scans: 0,
        today_valid_scans: 0,
        today_invalid_scans: 0,
        loadingData: true,

    },
    mutations: {
        addNumberScansData(state: any, which: any) {
            let number = 1;
            let date = new Date();
            let currentDate = date.toISOString().split('T')[0];
            state.all_scans = state.all_scans + number;
            localStorage.setItem('all_scans', state.all_scans);
            
            let storedDate = localStorage.getItem('storedDate');
            if (storedDate == null || storedDate == undefined) {
                storedDate = currentDate;
                localStorage.setItem('storedDate', currentDate);
            } else {
                if (currentDate == storedDate) {
                    state.today_scans = state.today_scans + number;
                    localStorage.setItem('today_scans', state.today_scans);
                } else {
                    state.today_scans = 0;
                    localStorage.setItem('today_scans', state.today_scans);
                }
            }
            
            if (which == 'valid') {
                state.all_valid_scans = state.all_valid_scans + number;
                localStorage.setItem('all_valid_scans', state.all_valid_scans);
                if (currentDate == storedDate) {
                    state.today_valid_scans = state.today_valid_scans + number;
                    localStorage.setItem('today_valid_scans', state.today_valid_scans);
                } else {
                    state.today_valid_scans = 0;
                    localStorage.setItem('today_valid_scans', state.today_valid_scans);
                }
            } 
            
            if (which == 'invalid') {
                state.all_invalid_scans = state.all_invalid_scans + number;
                localStorage.setItem('all_invalid_scans', state.all_invalid_scans);
                if (currentDate == storedDate) {
                    state.today_invalid_scans = state.today_invalid_scans + number;
                    localStorage.setItem('today_invalid_scans', state.today_invalid_scans);
                } else {
                    state.today_invalid_scans = 0;
                    localStorage.setItem('today_invalid_scans', state.today_invalid_scans);
                }
            }  
        },
        addNewRecentScan(state: any, data: any) {
            if (state.recent_scans.length < 4){
                state.recent_scans.unshift(data);
                localStorage.setItem('recent_scans', JSON.stringify(state.recent_scans));
            } else {
                state.recent_scans.pop();
                state.recent_scans.unshift(data);
                localStorage.setItem('recent_scans', JSON.stringify(state.recent_scans));
            }
        },
        getAllStoredData(state: any) {
             
            let __getProviderStoredData = 'https://bookinga.herokuapp.com/api/v1/ticket/scanning/report'

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }
                
            axios.get(`${__getProviderStoredData}`, config)
                .then(response => {

                    state.recent_scans = response.data.recentScans;
                    state.all_scans = parseInt(response.data.allScans[0].count);
                    state.all_valid_scans = parseInt(response.data.allValidScans[0].count);
                    state.all_invalid_scans = parseInt(response.data.allInvalidScans[0].count);
                    state.today_scans = parseInt(response.data.todayScans[0].count);
                    state.today_valid_scans = parseInt(response.data.todayValidScans[0].count);
                    state.today_invalid_scans = parseInt(response.data.todayInvalidScans[0].count);
                    state.loadingData = false;
                }).catch((err) => {
                    alert("Unable to get provider data. Try reloading . . .");
                    location.reload();
                    return;
                }) 
        }
        // getAllStoredData(state: any) {
        //     let all_scans = localStorage.getItem('all_scans');
        //     let today_scans = localStorage.getItem('today_scans');
        //     let all_valid_scans = localStorage.getItem('all_valid_scans');
        //     let today_valid_scans = localStorage.getItem('today_valid_scans');
        //     let all_invalid_scans = localStorage.getItem('all_invalid_scans');
        //     let today_invalid_scans = localStorage.getItem('today_invalid_scans');
        //     let recent_scans = localStorage.getItem('recent_scans');

        //     let date = new Date();
        //     let currentDate = date.toISOString().split('T')[0];
        //     let storedDate = localStorage.getItem('storedDate');

        //     if (all_scans != null || all_scans != undefined) {
        //         state.all_scans = parseInt(all_scans);
        //     } else {
        //         state.all_scans = 0;
        //         localStorage.setItem('all_scans', state.all_scans);
        //     }

        //     if (today_scans != null || today_scans != undefined) {
        //         if (currentDate == storedDate) {
        //             state.today_scans = parseInt(today_scans);
        //         } else {
        //             state.today_scans = 0;
        //             localStorage.setItem('storedDate', currentDate);
        //         }
        //     } else {
        //         if (currentDate == storedDate) {
        //             state.today_scans = 0;
        //             localStorage.setItem('today_scans', state.today_scans);
        //         } else {
        //             state.today_scans = 0;
        //             localStorage.setItem('storedDate', currentDate);
        //             localStorage.setItem('today_scans', state.today_scans);
        //         }
        //     }

        //     if (all_valid_scans != null || all_valid_scans != undefined) {
        //         state.all_valid_scans = parseInt(all_valid_scans);
        //     } else {
        //         state.all_valid_scans = 0;
        //         localStorage.setItem('all_valid_scans', state.all_valid_scans);
        //     }

        //     if (today_valid_scans != null || today_valid_scans != undefined) {
        //         if (currentDate == storedDate) {
        //             state.today_valid_scans = parseInt(today_valid_scans);
        //         } else {
        //             state.today_valid_scans = 0;
        //             localStorage.setItem('storedDate', currentDate);
        //         }
        //     } else {
        //         if (currentDate == storedDate) {
        //             state.today_valid_scans = 0;
        //             localStorage.setItem('today_valid_scans', state.today_valid_scans);
        //         } else {
        //             state.today_valid_scans = 0;
        //             localStorage.setItem('storedDate', currentDate);
        //             localStorage.setItem('today_valid_scans', state.today_valid_scans);
        //         }
        //     }

        //     if (all_invalid_scans != null || all_invalid_scans != undefined) {
        //         state.all_invalid_scans = parseInt(all_invalid_scans);
        //     } else {
        //         state.all_invalid_scans = 0;
        //         localStorage.setItem('all_invalid_scans', state.all_invalid_scans);
        //     }
            
        //     if (today_invalid_scans != null || today_invalid_scans != undefined) {
        //         if (currentDate == storedDate) {
        //             state.today_invalid_scans = parseInt(today_invalid_scans);
        //         } else {
        //             state.today_invalid_scans = 0;
        //             localStorage.setItem('storedDate', currentDate);
        //         }
        //     } else {
        //         if (currentDate == storedDate) {
        //             state.today_invalid_scans = 0;
        //             localStorage.setItem('today_invalid_scans', state.today_invalid_scans);
        //         } else {
        //             state.today_invalid_scans = 0;
        //             localStorage.setItem('storedDate', currentDate);
        //             localStorage.setItem('today_invalid_scans', state.today_invalid_scans);
        //         }
        //     }

        //     if (recent_scans != null || recent_scans != undefined) {
        //         state.recent_scans = JSON.parse(recent_scans);
        //     } else {
        //         state.recent_scans = [];
        //         localStorage.setItem('recent_scans', JSON.stringify(state.recent_scans));
        //     }

        // }
    },
    actions: { 

    },
    getters: {},
    modules: {}
}